import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { BaseQueryFn, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query'
import { logOut } from '../store/reducers/AuthSlice'

const isPlainObject = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && Object.getPrototypeOf(value) === Object.prototype

const toFormData = (body: Record<string, unknown>): FormData => {
  const formData = new FormData()

  for (const [key, value] of Object.entries(body)) {
    if (value === undefined) continue

    if (value instanceof Blob) formData.append(key, value)
    else if (typeof value === 'object' && value !== null)
      formData.append(key, JSON.stringify(value))
    else formData.append(key, String(value))
  }

  return formData
}

export const customBaseQuery = ({
  baseUrl = '/api',
  paramsSerializer,
}: {
  baseUrl: string
  paramsSerializer?: (params: any) => string
}): BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> => {
  return async (args, api, extraOptions) => {
    const request =
      typeof args !== 'string' && args.method && args.method !== 'GET' && isPlainObject(args.body)
        ? { ...args, body: toFormData(args.body) }
        : args

    const result = await fetchBaseQuery({
      baseUrl,
      ...(paramsSerializer && { paramsSerializer }),
    })(request, api, extraOptions)

    if (result.data && typeof result.data === 'object' && 'is_auth' in result.data) {
      if (!result.data.is_auth) {
        api.dispatch(logOut())
      }
    }

    if (result.data && typeof result.data === 'object' && 'need_reload_page' in result.data) {
      const response = result.data as any
      if (response.need_reload_page === true) {
        window.location.reload()
      }
    }

    return result
  }
}

export const baseApi = createApi({
  reducerPath: 'api',
  baseQuery: customBaseQuery({ baseUrl: '/api' }),
  tagTypes: [
    'Admin',
    'AdOverviewAffiliate',
    'AdvertiserReport',
    'Affiliate',
    'AffiliateRule',
    'CountriesFilter',
    'CurrentUser',
    'DomainTag',
    'LanguageCompliance',
    'N8n',
    'Network',
    'Notification',
    'OrganicReport',
    'Project',
    'ProjectsFilter',
    'Publisher',
    'Referral',
    'ResearchAffiliate',
    'SiteSettings',
    'Tariff',
    'TariffDetails',
    'Team',
    'Trademark',
    'TrademarkInfringements',
    'User',
  ],
  endpoints: () => ({}),
})
